/* eslint-disable */
import { useState, useMemo, useEffect } from "react";
import { useLocation } from "react-router";
import queryString from 'query-string';

import { useUser, RequestStatus } from "../../shared";

const initialState = {
  password: "" as string | undefined,
  newPassword: "" as string | undefined,
  confirmPassword: "" as string | undefined,
};

export type FieldPassword = "password" | "newPassword" | "confirmPassword";

export function useUserSettings() {
  const [user, status, , changePasswordUser] = useUser(); // TODO: Пересмотреть формат результата хука
  const [applied, setApplied] = useState<boolean>(false);
  const [state, setState] = useState(initialState);
  const [validNewPass, setValidNewPass] = useState(false);
  const [validPass, setValidPass] = useState(false);
  
  const location = useLocation();
  const userId = queryString.parse(location.search).userId;
  
  const resetUserSettings = () => {
    setState(initialState);
  };

  useEffect(() => {
    if (status === RequestStatus.Success) {
      setState({
        password: "",
        newPassword: "",
        confirmPassword: "",
      });

      setApplied(true);
    }
  }, [status]);

  const apply = useMemo(
    () => () => {
      const { password, newPassword } = state;
      changePasswordUser({
        currentPassword: password!,
        newPassword: newPassword!,
        user: userId || user.email,
      });
    },
    [state]
  );

  const changeField = useMemo(
    () => (fieldName: string, value: string | number) => {
      setState({
        ...state,
        [fieldName]: value,
      });
    },
    [state]
  );

  return {
    state,
    validPass,
    validNewPass,
    apply,
    resetUserSettings,
    changeField,
    setValidPass,
    setValidNewPass,
    status,
    applied,
  };
}
